// extracted by mini-css-extract-plugin
module.exports = {"container":"ProductDetailSection__container"};